<template>
  <div class="kye-filter-rule-group noselect" v-next>
    <div class="kye-filter-rule-group-num-head">
      <kye-select v-model="field" placeholder="请选择字段名" @change="fieldChange" @visible-change="e => fieldsGroupVisibleChange(e)">
        <kye-option
          v-for="item in fieldsGroup"
          v-if="item.show"
          :key="item.value"
          :disabled="item.disabled"
          :label="item.label"
          :value="item.value">
        </kye-option>
      </kye-select>
    </div>
    <div class="kye-filter-rule-group-body" :style="{ height: height + 'px' }">
      <div
        class="kye-filter-rule-group-num"
        v-show="showGroup(item)"
        v-for="(item, groupIndex) in rulesGroup"
        :key="groupIndex"
        @click.self="handleClick(groupIndex)">
      <!-- <div :class="groupIndex === 0 ? 'kye-filter-rule-group-num-head' : 'kye-filter-rule-group-num'" v-for="(item, groupIndex) in rulesGroup" :key="groupIndex" @click.self="handleClick(groupIndex)"> -->
        <!-- <div v-if="groupIndex === 0">
          <kye-select v-model="selectField" placeholder="请选择字段名" @change="fieldChange">
            <kye-option
              v-for="(item, field) in config.fields"
              :key="field"
              :label="item.columnDisplayName || item.label"
              :value="field">
            </kye-option>
          </kye-select>
        </div> -->
        <div class="kye-filter-rule-group-num-item" @click.stop="handleClick(groupIndex)">
          <span class="kye-filter-rule-group-num-title">{{ item.groupName }}</span>
          <!-- <span class="kye-filter-rule-group-num-operation">操作</span> -->
        </div>
        <el-table
          class="kye-filter-rule-group-table"
          :show-header="false"
          :data="item.rules"
          :stripe="false"
          :border="false"
          :row-class-name="rowClass"
          :highlight-current-row="false"
          v-if="showGroup(item)">
          <el-table-column width="20" align="center" label="序号">
            <div slot-scope="scope" class="td-row-num">{{ scope.$index + 1 }}</div>
          </el-table-column>
          <el-table-column width="32" align="center" label="(" label-class-name="td-front">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.frontBrackets"
                v-bind="frontBracketsAttr"
                style="width:28px;"
                :disabled="isDisabledBrackets(scope.row.key, item, scope.row, scope.$index, groupIndex)">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column width="120" align="left" label="查询条件">
            <template slot-scope="scope">
              <kye-select
                v-model="scope.row.key"
                placeholder="选择字段名"
                filterable
                default-first-option
                :clearable="false"
                @visible-change="e => fieldsVisibleChange(e, scope.row)"
                :disabled="isDisabled(scope.row.key, scope.$index, groupIndex, { type: 'key' })"
                @change="clearFieldValue(scope.row)">
                <el-option
                  v-for="opt in item.fields"
                  :key="opt.key"
                  v-if="showField(opt, item, scope.row, scope.$index, groupIndex)"
                  :disabled="isDisabledField(opt, item, scope.row, scope.$index, groupIndex)"
                  :label="opt.columnDisplayName || opt.label"
                  :value="opt.key">
                </el-option>
              </kye-select>
            </template>
          </el-table-column>
          <el-table-column width="80" align="left" label="条件关系">
            <template slot-scope="scope">
              <kye-select
                v-model="scope.row.operation"
                placeholder="请选择"
                default-first-option
                :clearable="false"
                :disabled="isDisabled(scope.row.key, scope.$index, groupIndex, { type: 'operation' })"
                @change="operationChange(scope.row)">
                <el-option
                  v-for="opt in config.operations"
                  v-if="isValidCompareOption(opt.value, item, scope.row, scope.$index, groupIndex)"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value">
                </el-option>
              </kye-select>
            </template>
          </el-table-column>
          <el-table-column align="left" label="条件值">
            <template slot-scope="scope">
              <kye-select
                v-if="typeof scope.row.remoteMethod === 'function'"
                :ref="`remoteSelect${scope.$index}`"
                class="kye-select--multiple"
                :placeholder="setPlaceholder(scope.row) || '请搜索'"
                v-bind="scope.row.$attr"
                :key="scope.row.key"
                clearable
                filterable
                :user="scope.row.columnType === 'user' || scope.row.$attr.user === true"
                :remoteMethod="e => remoteMethod(e, scope.row, scope.$index)"
                :loading="scope.row.loading"
                :value="scope.row.$attr.multiple ? (Array.isArray(scope.row.queryValue2) ? scope.row.queryValue2 : []) : scope.row.queryValue"
                :labels="selectedLabels(scope.row.options, scope.row.queryValue2, scope.row.$attr.multiple)"
                @input="e => bindChange(e, scope.row)"
                @change="queryValueChange(scope.row)"
                @visible-change="e => selectVisibleChange(e, scope.row)">
                <kye-option
                  v-for="opt in scope.row.options"
                  :class="opt.optionDisabled ? 'kyeuseroff' : ''"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value">
                </kye-option>
              </kye-select>
              <div v-else-if="isInputRange(scope.row)" style="display:flex;">
                <kye-number
                  v-model="scope.row.queryValue"
                  v-bind="scope.row.$attr"
                  style="flex:1;"
                  :placeholder="setPlaceholder(scope.row) || '请输入数字'">
                </kye-number>
                <span style="padding: 0 4px;line-height: 28px;">-</span>
                <kye-number
                  v-model="scope.row._queryValue"
                  v-bind="scope.row.$attr"
                  style="flex:1;"
                  :placeholder="setPlaceholder(scope.row) || '请输入数字'">
                </kye-number>
              </div>
              <el-radio-group
                v-else-if="isInputNumberComponent(scope.row) && scope.row.$attr.null && ['equal', 'not_equal'].includes(scope.row.operation)"
                v-model="scope.row._queryValue"
                @change="e => radioNumberChange(scope.row, e)">
                <el-radio label="number" style="width:202px;">
                  <kye-number
                    style="width: 92%"
                    v-model="scope.row.queryValue"
                    v-bind="scope.row.$attr"
                    :disabled="scope.row._queryValue === 'null'"
                    :placeholder="setPlaceholder(scope.row) || '请输入数字'">
                  </kye-number>
                </el-radio>
                <el-radio label="null">
                  <el-input
                    style="width:30px;"
                    :disabled="scope.row._queryValue !== 'null'"
                    value="(空)"
                    readonly>
                  </el-input>
                </el-radio>
              </el-radio-group>
              <kye-number
                v-else-if="isInputNumberComponent(scope.row)"
                v-model="scope.row.queryValue"
                v-bind="scope.row.$attr"
                :placeholder="setPlaceholder(scope.row) || '请输入数字'">
              </kye-number>
              <template v-else-if="isInputComponent(scope.row) && scope.row.operation">
                <el-radio-group
                  v-if="scope.row.$attr.null && ['equal', 'not_equal'].includes(scope.row.operation)"
                  v-model="scope.row._queryValue"
                  @change="e => radioInputChange(scope.row, e)">
                  <el-radio label="text" style="width:196px;">
                    <el-input
                      style="width:92%;"
                      v-model.trim="scope.row.queryValue"
                      v-bind="scope.row.$attr"
                      :disabled="scope.row._queryValue === 'null'"
                      :placeholder="setPlaceholder(scope.row) || '请输入内容'">
                    </el-input>
                  </el-radio>
                  <el-radio label="null">
                    <el-input
                      style="width:30px;"
                      :disabled="scope.row._queryValue !== 'null'"
                      value="(空)"
                      readonly>
                    </el-input>
                  </el-radio>
                </el-radio-group>
                <el-input
                  v-else
                  v-model.trim="scope.row.queryValue"
                  v-bind="scope.row.$attr"
                  :placeholder="setPlaceholder(scope.row) || '请输入内容'">
                </el-input>
              </template>
              <template v-else-if="getComponentType(scope.row) === 'enum'">
                <kye-select
                  v-show="isEmptyOperation(scope.row)"
                  clearable
                  filterable
                  default-first-option
                  :placeholder="setPlaceholder(scope.row) || '请选择'"
                  v-model="scope.row.queryValue"
                  v-bind="scope.row.$attr"
                  @change="queryValueChange(scope.row)">
                  <el-option
                    v-for="opt in getFieldOptions(scope.row)"
                    :key="opt.value"
                    :label="opt.label || ' '"
                    :value="opt.value">
                  </el-option>
                </kye-select>
                <kye-select
                  v-show="!isEmptyOperation(scope.row)"
                  class="kye-select--multiple"
                  multiple
                  collapse-tags
                  filterable
                  default-first-option
                  :placeholder="setPlaceholder(scope.row) || '请选择'"
                  v-model="scope.row.queryValue2"
                  v-bind="scope.row.$attr"
                  :labels="selectedLabels(getFieldOptions(scope.row), scope.row.queryValue2, true)"
                  @change="queryValueChange(scope.row)">
                  <el-option
                    v-for="opt in getFieldOptions(scope.row)"
                    :key="opt.value"
                    :label="opt.label || ' '"
                    :value="opt.value">
                  </el-option>
                </kye-select>
              </template>
              <template v-else-if="getComponentType(scope.row) === 'date'">
                <el-radio-group
                  v-if="scope.row.operation === 'equal' && scope.row.$attr.null !== false"
                  v-model="scope.row._queryValue"
                  @change="e => radioDateChange(scope.row, e)">
                  <el-radio label="date" style="width:170px;">
                    <el-time-picker
                      v-if="getSelectField(scope.row).lookupCode === 'time'"
                      v-model="scope.row.queryValue"
                      style="width:92%;"
                      v-bind="scope.row.$attr"
                      :format="scope.row.$attr.format || 'HH:mm:ss'"
                      :value-format="scope.row.$attr.valueFormat || 'HH:mm:ss'"
                      :disabled="scope.row._queryValue === 'null'"
                      :clearable="false"
                      placeholder="请选择时间">
                    </el-time-picker>
                    <kye-date-picker3
                      v-else-if="getSelectField(scope.row).lookupCode === 'datePicker3'"
                      v-model="scope.row.queryValue"
                      style="width: 92%; display: inline-block"
                      v-bind="scope.row.$attr"
                      :disabled="scope.row._queryValue === 'null'"
                      :clearable="false"
                      :operation="scope.row.operation"
                      :type="getDatePickerType(scope.row.key)"
                      @input="val => datePickerChange(val, scope.row)">
                    </kye-date-picker3>
                    <kye-date-picker
                      v-else
                      v-model="scope.row.queryValue"
                      style="width:92%;"
                      v-bind="scope.row.$attr"
                      :disabled="scope.row._queryValue === 'null'"
                      :clearable="false"
                      :operation="scope.row.operation"
                      :type="getDatePickerType(scope.row.key)"
                      @input="(val) => datePickerChange(val, scope.row)">
                    </kye-date-picker>
                  </el-radio>
                  <el-radio label="null">
                    <el-input
                      style="width:30px;"
                      :disabled="scope.row._queryValue !== 'null'"
                      value="(空)"
                      readonly>
                    </el-input>
                  </el-radio>
                </el-radio-group>
                <el-input v-else-if="scope.row.operation === 'not_equal'" value="(空)" disabled />
                <template v-else>
                  <template v-if="getSelectField(scope.row).lookupCode === 'time'">
                    <el-time-picker
                      v-show="!isRange(scope.row)"
                      v-model="scope.row.queryValue"
                      v-bind="scope.row.$attr"
                      :format="scope.row.$attr.format || 'HH:mm:ss'"
                      :value-format="scope.row.$attr.valueFormat || 'HH:mm:ss'"
                      :clearable="false"
                      placeholder="请选择时间">
                    </el-time-picker>
                    <el-time-picker
                      v-model="scope.row.queryValue2"
                      v-show="isRange(scope.row)"
                      v-bind="scope.row.$attr"
                      :format="scope.row.$attr.format || 'HH:mm:ss'"
                      :value-format="scope.row.$attr.valueFormat || 'HH:mm:ss'"
                      is-range
                      :clearable="false"
                      start-placeholder="开始时间"
                      end-placeholder="结束日时间">
                    </el-time-picker>
                  </template>
                  <template v-else-if="getSelectField(scope.row).lookupCode === 'datePicker3'">
                    <kye-date-picker3
                      v-show="!isRange(scope.row)"
                      v-model="scope.row.queryValue"
                      v-bind="scope.row.$attr"
                      :clearable="false"
                      :operation="scope.row.operation"
                      :type="getDatePickerType(scope.row.key)"
                      placeholder="请选择日期"
                      @input="val => datePickerChange(val, scope.row)">
                    </kye-date-picker3>
                    <kye-date-picker3
                      v-model="scope.row.queryValue2"
                      v-show="isRange(scope.row)"
                      v-bind="scope.row.$attr"
                      :clearable="false"
                      :operation="scope.row.operation"
                      :type="getDatePickerType(scope.row.key, true)"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @input="val => datePickerChange(val, scope.row)">
                    </kye-date-picker3>
                  </template>
                  <template v-else>
                    <kye-date-picker
                      v-show="!isRange(scope.row)"
                      v-model="scope.row.queryValue"
                      v-bind="scope.row.$attr"
                      :clearable="false"
                      :operation="scope.row.operation"
                      :type="getDatePickerType(scope.row.key)"
                      placeholder="请选择日期"
                      @input="(val) => datePickerChange(val, scope.row)">
                    </kye-date-picker>
                    <kye-date-picker
                      v-model="scope.row.queryValue2"
                      v-show="isRange(scope.row)"
                      v-bind="scope.row.$attr"
                      :clearable="false"
                      :operation="scope.row.operation"
                      :type="getDatePickerType(scope.row.key, true)"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @input="(val) => datePickerChange(val, scope.row)">
                    </kye-date-picker>
                  </template>
                </template>
              </template>
              <kye-area-remote
                v-else-if="getComponentType(scope.row) === 'area'"
                v-model="scope.row.queryValue2"
                :level="scope.row.$attr.options.length"
                :labels="scope.row.$attr.labels">
              </kye-area-remote>
              <el-input
                v-else-if="getComponentType(scope.row) === 'dept'"
                v-bind="scope.row.$attr"
                readonly
                :placeholder="setPlaceholder(scope.row) || '点击可选择组织'"
                :value="showDeptLabel(scope.row)"
                @focus="openDeptTree(scope.row, scope.$index, groupIndex)">
              </el-input>
              <formatter v-else-if="getComponentType(scope.row) === 'customComponent'" :option="warpCustomComponentsOption(scope.row)" v-bind="scope.row.$attr" />
              <el-input placeholder="请选择查询条件和条件关系" disabled v-else></el-input>
            </template>
          </el-table-column>
          <el-table-column width="32" align="center" label=")" label-class-name="td-post">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.postBrackets"
                v-bind="postBracketsAttr"
                style="width:28px;"
                :disabled="isDisabledBrackets(scope.row.key, item, scope.row, scope.$index, groupIndex)">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column width="94" align="left" label="条件间关系">
            <template slot-scope="scope">
              <kye-select
                v-model="scope.row.conditionOperation"
                :clearable="false"
                style="width:42px;"
                :disabled="isDisabledConditionOperation(scope.row.key, item, scope.row, scope.$index, groupIndex)">
                <el-option
                  v-for="opt in config.conditionOperation"
                  :key="opt.value"
                  :disabled="scope.row.disabledOperation"
                  :label="opt.label"
                  :value="opt.value">
                </el-option>
              </kye-select>
              <i class="layout layout-remove"
                v-show="showDeleteIcon(scope.row.key, scope.$index, groupIndex)"
                @click.stop="deleteRule(scope.$index, groupIndex)">
              </i>
              <i class="layout layout-plus2"
                v-show="showAddIcon(scope.row.key, scope.$index, groupIndex)"
                @click.stop="insertRule(scope.$index + 1, groupIndex)">
              </i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <dept-dialog ref="deptDialog" :preloadDeptTree="false" @change="deptChange"></dept-dialog>
    <dept-multiple-dialog ref="deptMultipleDialog" :preloadDeptTree="false" @change="deptChange"></dept-multiple-dialog>
  </div>
</template>

<script>
  import moment from 'moment'
  import { getGenericSearchConfig } from 'public/utils/common-api'
  import DeptDialog from './dept-dialog'
  import DeptMultipleDialog from './dept-multiple-dialog'
  import mixins from '../../mixins/index'
  import {
    OPERATIONS,
    COLUMN_TYPE,
    COMPARES,
    SINGLE_VALUE,
    perfectVos,
    remoteSelectMethod,
    navigateSelectFirstOption,
    createOnInputReplacer
  } from './utils'
  import { getMenuIdByRoute } from '../../utils'
  import Formatter from './form-item-formatter'
  import { createRemoteModel } from './module/custom-filter/create-rules'

  export default {
    mixins: [mixins],
    name: 'filter-rule-group',
    components: { DeptDialog, DeptMultipleDialog, Formatter },
    props: {
      inner: Boolean,
      height: [String, Number],
      searchCodes: { // 通用查询编码集合，对于通用查询配置比较多的模块，可传入此参数，减少响应时间
        type: Array,
        default: () => ([])
      },
      module: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      const lookUpOptions = this.$store.getters.lookUpOptions
      return {
        showIndex: '-1,-1', // 弹窗组件对应 rulesGroup 索引 groupIndex,index
        field: '',
        fieldsGroup: [],
        rulesGroup: [this.createdGroup()],
        config: {
          esFlag: true,
          fields: {},
          conditionOperation: lookUpOptions['system_GenericQuery_conditionOperation'],
          operations: lookUpOptions['system_GenericQuery_Operation']
        },
        frontBracketsAttr: createOnInputReplacer(/[^(（]/g),
        postBracketsAttr: createOnInputReplacer(/[^)）]/g)
      }
    },
    async created () {
      // this.fieldOptionsCache = {}
      if (!this.module.option) {
        this.module.option = {}
      }
      if (!this.inner && this.module.searchCode) {
        // let menuId = this.$store.getters.menus[this.$route.meta.tag].id
        let menu = getMenuIdByRoute(this.$store, this.$route)
        let menuId = menu && menu.id
        let rs = await getGenericSearchConfig(menuId, this.$props.searchCodes)
        if (rs && rs.length) {
          let obj = rs.find(v => v.searchCode === this.module.searchCode)
          if (obj && obj.columnList && obj.columnList.length) {
            this.config.esFlag = obj.esFlag === '10'
            obj.columnList.forEach(v => {
              v.key = this.config.esFlag ? v.propertyName : v.columnName
            })
            this.setGenericSearchFields(obj.columnList)
          }
        }
      }
    },
    beforeDestroy () {
      this.scrollDom = null
    },
    methods: {
      createdModel () {
        return {
          key: '',
          propertyName: '',
          columnName: '',
          frontBrackets: '(',
          postBrackets: ')',
          conditionOperation: 'and',
          operation: '',
          columnType: '',
          queryValue: '',
          queryValue2: null,
          disabledRemove: false, // 是否禁用删除按钮
          disabledOperation: false, // 是否禁用或与
          _queryValue: '',
          $attr: {}
        }
      },
      createdGroup () {
        return {
          rules: [this.createdModel()],
          fields: {},
          groupName: ''
        }
      },
      showGroup (item) {
        return Object.values(item.fields).filter(item => item.hasOwnProperty(`_show-${item.groupName}`) ? item[`_show-${item.groupName}`] : item.show).length >= 1
      },
      /**
       * 创建默认配置
       */
      createdDefaultModel () {
        let obj = {}
        Object.keys(this.module.option).forEach(v => {
          let conf = this.module.option[v]
          let field = this.config.fields[v]
          if (field && conf.required && conf.operation) {
            let model = this.createdModel()
            model._required = true // 根据标识判断是否必填
            model.key = v
            model.propertyName = field.propertyName
            model.columnName = field.columnName
            model.columnType = field.columnType
            model.$attr = field.$attr
            model.operation = conf.operation
            let value = conf.default
            if (model.columnType === COLUMN_TYPE.date) {
              if (this.isRange(model)) {
                model.queryValue2 = Array.isArray(value) && value.length
                  ? value.map(v => this.formatTime(v, field.lookupCode))
                  : null
              } else {
                model.queryValue = this.formatTime(value, field.lookupCode)
              }
            } else {
              // 2023-03-25 远程下拉搜索、远程搜索默认值
              if (field.remoteMethod) {
                model = {
                  ...model,
                  ...createRemoteModel(value, field)
                }
              } else {
                model.queryValue2 = value
                if (Array.isArray(value)) {
                  model.queryValue = value[0]
                  model._queryValue = value[1]
                } else {
                  model.queryValue = value
                }
                // 单选框赋值
                if (this.isInputComponent(field) && field.$attr.null && ['equal', 'not_equal'].includes(model.operation) && model.queryValue) {
                  model._queryValue = 'text'
                }
              }
            }
            // 一个字段多个分组
            if (this.hasGroupNames(field)) {
              field.groupNames.forEach(name => {
                let required = model._required
                if (typeof conf.required === 'function') {
                  required = conf.required({ groupName: name, field, row: model })
                }
                if (required) {
                  obj[`${v}@@${name}`] = {
                    ...model,
                    required
                  }
                }
              })
            } else {
              obj[v] = model
            }
          }
        })
        return obj
      },
      hasGroupNames (field) {
        return field && field.hasOwnProperty('groupNames') && Array.isArray(field.groupNames) && field.groupNames.length > 0
      },
      getFields () {
        let arr = []
        const obj = this.config.fields
        for (let key in obj) {
          const item = obj[key]
          const value = key
          const label = item.columnDisplayName || item.label
          // 一个字段多个分组
          if (this.hasGroupNames(item)) {
            item.groupNames.forEach(groupName => {
              arr.push({
                show: item[`_show-${groupName}`],
                disabled: item[`_disabled-${groupName}`],
                value: `${value}，${groupName}`,
                label: `${label}(${groupName})`
              })
            })
          } else {
            const groupName = item.groupName
            arr.push({
              show: item[`_show-${groupName}`],
              disabled: item[`_disabled-${groupName}`],
              value,
              label
            })
          }
        }
        return arr
      },
      /**
       * 设置通用查询分组
       */
      setGenericGroup () {
        let fields = this.config.fields
        let arr = []

        const addFunc = (field, name, key) => {
          const isHas = arr.some(v => {
            const hasName = name === v.groupName
            if (hasName) {
              v.fields[key] = field
              return true
            }
          })
          if (!isHas) {
            let o = {
                rules: [this.createdModel()],
                fields: {},
                groupName: name
              }
              o.fields[key] = field
              arr.push(o)
          }
        }

        for (let key in fields) {
          const field = fields[key]
          const has = this.hasGroupNames(field)
          if (has) {
            field.groupNames.forEach(name => addFunc(field, name, key))
          } else {
            addFunc(field, field.groupName, key)
          }
        }

        return arr
      },
      /**
       * 默认字段合并分组
       */
      mergeGroup () {
        const fields = this.config.fields
        const conf = this.createdDefaultModel()
        let group = this.setGenericGroup()
        for (let k in conf) {
          const has = k.includes('@@')
          const key = has ? k.split('@@')[0] : k
          const name = has ? k.split('@@')[1] : fields[key].groupName
          group.some(v => {
            let groupName = v.groupName
            if (groupName === name) {
              if (!v.rules[0].key) {
                v.rules = [conf[k]]
              } else {
                v.rules.push(conf[k])
              }
              return true
            }
          })
        }

        // 如果第一组没有字段，则删除该分组
        if (this.isEmptyObject(group[0].fields)) {
          group.splice(0, 1)
        }

        this.filterGroup(group)

        return group
      },
      // 筛选分组条件值
      filterGroup (arr) {
        arr.forEach((v, groupIndex) => {
          let rules = v.rules

          // 过滤字段无需显示情况
          rules = rules.filter((rule, index) => {
            if (rule.key) {
              const field = v.fields[rule.key]
              return this.showField(field, v, rule, index, groupIndex)
            }
          })

          // 处理模版分组无数据情况
          if (rules.length === 0) {
            v.rules = [this.createdModel()]
          }
        })
      },
      // 对外暴露，merge 查询条件
      setGenericFields (option) {
        Object.keys(option).forEach(v => {
          let opt = this.config.fields[v]
          if (opt) {
            Object.assign(opt, option[v])
          }
        })
      },
      /**
       * 设置通用查询字段
       */
      setGenericSearchFields (fields, esFlag) {
        if (esFlag !== void 0) {
          this.config.esFlag = esFlag
        }
        if (!Object.keys(this.config.fields).length) {
          this.perfectModuleOption(fields)
          this.config.fields = fields.reduce((s, v) => {
            this.$set(v, 'show', true)
            this.$set(v, 'disabledField', false)
            // merge 前端的配置
            v.$attr = Object.assign(v.$attr || {}, this.module.option[v.key])
            // 后台扩展字段支持前端属性
            let attr = v.attribute2
            if (attr) {
              if (typeof attr === 'string') {
                try {
                  attr = JSON.parse(attr)
                } catch (e) {
                }
              }
              if (typeof attr === 'object') {
                // 前端的配置覆盖模板的配置
                Object.assign(attr, v.$attr)
                Object.assign(v.$attr, attr)
              }
            }
            let type = v.columnType === 'component' ? (v.lookupCode || COLUMN_TYPE.string) : v.columnType
            v.columnType = type
            v.remoteMethod = v.$attr.remoteMethod
            if (type === COLUMN_TYPE.area) {
              let labels = v.$attr.options.map(v => v.label)
              v.label = labels.join('-')
              v.$attr.labels = labels
            } else if (type === COLUMN_TYPE.user) {
              v.remoteMethod = val => this.searchUser(val, v)
              v.$attr.remote = true
            } else if (type === COLUMN_TYPE.department) {
              v.remoteMethod = this.searchDepartment
              v.$attr.remote = true
            } else if (type === COLUMN_TYPE.date) {
              if (v.lookupCode === 'time') {
                v.$attr.type = v.$attr.type || 'time'
                v.$attr.format = v.$attr.format || 'HH:mm:ss'
                v.$attr.valueFormat = v.$attr.valueFormat || 'HH:mm:ss'
              } else {
                v.$attr.type = v.$attr.type || 'datetime'
                v.$attr.format = v.$attr.format || 'yyyy-MM-dd HH:mm'
                v.$attr.valueFormat = v.$attr.valueFormat || 'yyyy-MM-dd HH:mm:ss'
              }
            }
            s[v.key] = v
            return s
          }, {})
        }
        this.rulesGroup = this.mergeGroup()
      },
      /**
       * 完善前端属性配置
       */
      perfectModuleOption (fields) {
        Object.keys(this.module.option).forEach(k => {
          fields.some(v => {
            if (k === v.propertyName) {
              this.module.option[v.columnName] = this.module.option[k]
              return true
            }
            if (k === v.columnName) {
              this.module.option[v.propertyName] = this.module.option[k]
              return true
            }
            return false
          })
        })
      },
      /**
       * 获取原通用查询，分组查询
       */
      getValidRules () {
        let arr = []
        let rulesGroup = this.getRulesGroup()
        rulesGroup.forEach(item => {
          item.rules.forEach(v => {
            if (v.operation && this.isValidQueryValue(v)) {
              let o = {
                propertyName: v.propertyName,
                columnName: v.columnName,
                frontBrackets: v.frontBrackets,
                postBrackets: v.postBrackets,
                conditionOperation: v.conditionOperation,
                operation: v.operation,
                queryValue: this.getQueryValueTemplate(v),
                extJson: this.setExtJson(v, item)
              }
              arr.push(o)
            }
          })
        })
        return arr
      },
      /**
       * 设置分组规则为空
       */
      setEmptyRulesGroup () {
        let group = this.getRulesGroup()
        let arr = []
        group.forEach(v => {
          arr.push({
            ...v,
            rules: []
          })
        })
        return arr
      },
      /**
       * 获取实际分组通用查询
       */
      getRulesGroup () {
        return this.rulesGroup
      },
      /**
       * 获取实际分组通用查询
       */
      getRules () {
        return this.rulesGroup.reduce((prev, cur) => {
          prev.push(...cur.rules)
          return prev
        }, [])
      },
      /**
       * 从缓存中设置通用查询
       */
      setRules (rules) {
         if (rules && typeof rules === 'string') {
          try {
            rules = JSON.parse(rules)
          } catch (e) {
            rules = null
          }
        }
        let key = this.config.esFlag ? 'propertyName' : 'columnName'
        let fields = this.config.fields
        let arr = this.setEmptyRulesGroup()

        const fieldsConf = this.createdDefaultModel() // 默认必填规则
        const rulesKeys = [] // 收集回显字段

        Array.isArray(rules) && rules.forEach(v => {
          let field = fields[v[key]]
          if (!field) {
            return false
          }
          let type = field.columnType
          // 扩展字段
          let ext = {}
          try {
            ext = JSON.parse(v.extJson)
          } catch (e) {
            ext = {}
          }
          const conditionGroupName = ext.groupName || field.groupName
          const fieldKey = v[key]
          // 对比配置数据与后台数据是否必填一致（必填字段没有变化）
          const _key = this.hasGroupNames(field) ? `${fieldKey}@@${conditionGroupName}` : fieldKey
          const required = !!(fieldsConf[_key] && ext.required)
          v.key = fieldKey

          v._required = required || v.required
          rulesKeys.push(fieldKey)

          v.columnType = type
          v.$attr = field.$attr
          // v._required = v.required
          v._queryValue = ''
          v.queryValue2 = null
          if (!v.conditionOperation) {
            v.conditionOperation = 'and'
          }
          let value = v.values || v.queryValue || []
          // 解析模板值
          if (field.remoteMethod) {
            v.remoteMethod = field.remoteMethod
            // 2022-11-28 增加属性
            v.labelKey = field.$attr.labelKey
            v.valueKey = field.$attr.valueKey
            v.options = []
            try {
              let arr = JSON.parse(value)
              v.options = Array.isArray(arr) ? arr : []
              if (v.$attr.multiple) {
                v.allSearchResult = arr.reduce((prev, cur) => {
                  prev[cur.value] = cur
                  return prev
                }, {})
              }
              value = arr.map(item => item.value)
            } catch (e) {
              value = value.split(',')
            }
          } else if (type === COLUMN_TYPE.dept) {
            try {
              let arr = JSON.parse(value)
              value = arr[0].value
              v._queryValue = arr
            } catch (e) {
              value = value.split(',')
              v._queryValue = value
            }
            v.queryValue2 = value
            v._containLeaf = ext.containLeaf
            v._idsInfo = ext.idsInfo
          } else if (value && typeof value === 'string') {
            value = value.split(',')
          }
          // 将值拆分到对应字段
          if (type === COLUMN_TYPE.date) {
            if (!field.lookupCode && v.operation === OPERATIONS.equal) {
              v.queryValue = value[0].replace('null', '')
              v._queryValue = value[0]
            } else {
              v.queryValue = this.formatTime(value[0], field.lookupCode)
            }
            v.queryValue2 = value.length === 2 ? value.map(v => this.formatTime(v, field.lookupCode)) : []
          } else if (type === COLUMN_TYPE.area) {
            v.queryValue2 = value.map(v => ({ id: v }))
          } else if (this.isInputComponent(field) && !field.remoteMethod) {
            if (field.$attr.null && ['equal', 'not_equal'].includes(v.operation) && v.queryValue === 'null') {
              v.queryValue = ''
              v._queryValue = 'null'
            } else {
              // 多个字符串拼接查询功能，例如 1,4,5
              v.queryValue = value.join(',')
              v._queryValue = ''
            }
          } else if (type === COLUMN_TYPE.customComponent) {
            let arr = null
            try {
              arr = JSON.parse(value)
            } catch (e) {
              arr = null
            }
            const { customSetQueryValue } = field.$attr
            // 用于自定义组件，自定义输入值
            if (customSetQueryValue && typeof customSetQueryValue === 'function') {
              customSetQueryValue(v, { values: arr })
            } else {
              // 区分内外存储格式方式，外部是values：[]  内部是[{ value, label }]
              if (Array.isArray(arr)) {
                v.queryValue = (arr[0] && arr[0].label) || ''
                v._queryValue = arr
                v.queryValue2 = (arr[0] && arr[0].value) || ''
              } else {
                v.queryValue = ''
                v._queryValue = [{ value, label: '' }]
                v.queryValue2 = value
              }
            }
          } else if (type !== COLUMN_TYPE.dept) {
            v.queryValue = value[0]
            v._queryValue = value[1]
            v.queryValue2 = value
          }
          arr.some(group => {
            if (conditionGroupName === group.groupName) {
              group.rules.push(v)
              return true
            }
          })
        })

        // 验证必填字段是否已经被设置
        const defaultKeys = Object.keys(fieldsConf)
        defaultKeys.forEach(k => {
          const model = fieldsConf[k]
          const has = k.includes('@@')
          const key = has ? k.split('@@')[0] : k
          const groupName = has ? k.split('@@')[1] : fields[key].groupName

          // const field = fields[key]
          // const groupName = field.groupName
          const findObj = arr.find(group => group.groupName === groupName)

          // 必填字段不在模版里面（新增必填字段）
          if (findObj && !rulesKeys.includes(key)) {
            findObj.rules.unshift(model)
          }

          // 默认里面，必填字段未保存（字段由非必填变为必填）
          const noRequired = findObj.rules.filter(item => item.key === key).every(item => !item._required)
          if (noRequired) {
            findObj.rules.unshift(model)
          }
        })

        this.filterGroup(arr)

        this.rulesGroup = arr

        // 加载完成后-操作
        const { listeners } = this.module
        if (listeners && listeners.setRulesComplete && typeof listeners.setRulesComplete === 'function') {
          listeners.setRulesComplete(this, { fields: this.config.fields, rules: this.getRules(), rulesGroup: this.rulesGroup })
        }
      },
      /**
       * 组装通用查询
       */
      appendGenericVos (rules = []) {
        const vos = []
        const componentMap = {
          [COLUMN_TYPE.user]: COLUMN_TYPE.string,
          [COLUMN_TYPE.department]: COLUMN_TYPE.string,
          [COLUMN_TYPE.phone]: COLUMN_TYPE.string,
          [COLUMN_TYPE.dept]: COLUMN_TYPE.string,
          [COLUMN_TYPE.customComponent]: COLUMN_TYPE.string
        }
        rules.forEach(obj => {
          let values = this.getQueryValue(obj)
          let type = obj.columnType
          let vo = {
            propertyName: obj.propertyName,
            columnName: obj.columnName,
            frontBrackets: obj.frontBrackets,
            postBrackets: obj.postBrackets,
            conditionOperation: obj.conditionOperation,
            operation: obj.operation,
            type: componentMap[type] || type,
            values
          }
          // 扩展字段
          let field = this.config.fields[obj.key] || {}
          if (field.attribute1) {
            try {
              Object.assign(vo, JSON.parse(field.attribute1))
            } catch (e) {
            }
          }
          if (type === COLUMN_TYPE.area) {
            let options = field.$attr.options
            let lastIndex = values.length - 1
            values.forEach((v, index) => {
              if (v) {
                let opt = options[index]
                vos.push({
                  propertyName: opt.propertyName,
                  columnName: opt.columnName,
                  // 2022-07-18 首位两端取用户输入值
                  frontBrackets: index === 0 ? obj.frontBrackets : '(',
                  postBrackets: index === lastIndex ? obj.postBrackets : ')',
                  conditionOperation: index === lastIndex ? obj.conditionOperation : 'and',
                  operation: obj.operation,
                  type: opt.columnType,
                  values: [v]
                })
              }
            })
          } else if (type === COLUMN_TYPE.date && obj.operation === OPERATIONS.equal) {
            if (obj._queryValue === 'null') {
              vo.values = ['null']
            } else {
              let type = field.$attr.type || 'date'
              vo.values = this.calculateDateRange(obj.queryValue, type, obj.$attr.valueFormat)
              if (type.includes('date')) {
                vo.operation = OPERATIONS.between
              }
            }
            vos.push(vo)
          } else if (type === COLUMN_TYPE.dept) {
            vo.containLeaf = obj._containLeaf
            vo.idsInfo = obj._idsInfo
            if (obj.operation.includes(OPERATIONS.contain)) {
              vo.type = COLUMN_TYPE.enum
            }
            vos.push(vo)
          } else {
            vos.push(vo)
          }
        })
        return vos
      },
      /**
       * 组装通用查询-分组
       */
      appendGenericVosGroup () {
        let rulesGroup = this.getRulesGroup()
        let obj = {}
        rulesGroup.forEach(v => {
          let groupName = v.groupName
          if (groupName) {
            let isHas = v.rules.some(v => !!v.key)
            // 去掉非必填
            let vos = []
            if (isHas) {
              vos = this.appendGenericVos(v.rules)
              perfectVos(vos)
            }
            obj[v.groupName] = { vos }
          }
        })
        return obj
      },
      isHasGenericVos () {
        let group = this.getRulesGroup()
        // 原有通用查询首行为空情况
        return !group[0].groupName && (group[0].rules[0] && group[0].rules[0].key)
      },
      isHasGenericVosGroup () {
        let group = this.getRulesGroup()
        return group.some(v => !!v.groupName)
      },
      handleClick (groupIndex) {
        // if (groupIndex === 0) return
        this.addRule(groupIndex)
      },
      /**
       * 提交查询参数
       */
      onSubmit () {
        let allRules = this.getRules()
        // [{ rules: [this.createdModel()], fields: {}, groupName: '' }]
        let rulesGroup = this.getRulesGroup()
        let groupL = rulesGroup.length
        // let isHasRule = false
        let noHasRule = allRules.every(v => !v.key)
        if (noHasRule) {
          this.$message.warning(`请添加查询条件！`)
          return null
        }

        for (let i = 0; i < groupL; i++) {
          let groupName = rulesGroup[i].groupName
          let rules = rulesGroup[i].rules
          let rulesL = rules.length
          let frontNum = 0
          let postNum = 0
          for (let j = 0; j < rulesL; j++) {
            let obj = rules[j]
            let condition = rulesL >= 2
            let tip = groupName ? `分组【${groupName}】` : ''
            if ((obj.key || condition) && !this.isValidQueryValue(obj)) {
              this.$message.warning(tip + `第${j + 1}行的条件值不能为空`)
              return null
            }
            if ((obj.key || condition) && !obj.operation) {
              this.$message.warning(tip + `第${j + 1}行的条件关系不能为空`)
              return null
            }
            if (this.isInputComponent(obj) && this.getQueryValue(obj).join().length > 255) {
              this.$message.warning(tip + `第${i + 1}行的条件值字符长度不能大于255`)
              return null
            }
            obj.frontBrackets = obj.frontBrackets ? obj.frontBrackets.replace(/（/g, '(') : ''
            obj.postBrackets = obj.postBrackets ? obj.postBrackets.replace(/）/g, ')') : ''
            frontNum += obj.frontBrackets.length
            postNum += obj.postBrackets.length
          }
          if (frontNum !== postNum) {
            let tip = groupName ? `分组【${groupName}】` : ''
            this.$message.warning(tip + '前后括号数量不一致！')
            return null
          }
        }

        let vos = []
        let group = this.appendGenericVosGroup()
        if (this.isHasGenericVos()) {
          vos = this.appendGenericVos(rulesGroup[0].rules)
          perfectVos(vos)
        }
        console.log('onSubmit', vos, group)
        return {
          vos,
          group
        }
      },
      mapColumnList () {
        let arr = []
        let group = this.getRulesGroup()
        group.forEach(item => {
          item.rules.forEach((v, i) => {
            if (!v.key) {
              return
            }
            arr.push({
              rowIndex: i + 1,
              propertyName: v.propertyName,
              columnName: v.columnName,
              frontBrackettemplates: v.frontBrackets,
              postBrackets: v.postBrackets,
              conditionOperation: v.conditionOperation,
              operation: v.operation,
              queryValue: this.getQueryValueTemplate(v),
              extJson: this.setExtJson(v, item)
            })
          })
        })
        return arr
      },
      setExtJson (model, groupRow) {
        let obj = {}
        const type = model.columnType
        // 是否包含子节点
        if (type === COLUMN_TYPE.dept) {
          obj.containLeaf = model._containLeaf
          obj.idsInfo = model._idsInfo
        }
        // 必填
        if (model._required) {
          obj.required = true
        }
        obj.groupName = groupRow.groupName
        return JSON.stringify(obj)
      },
      /**
       * 组内向后添加规则
       */
      addRule (groupIndex) {
        this.rulesGroup[groupIndex].rules.push(this.createdModel())
      },
      /**
       * 增加组内条件
       */
      insertRule (index, groupIndex) {
        this.rulesGroup[groupIndex].rules.splice(index, 0, this.createdModel())
        this.$emit('onInsertRule', this, { fields: this.config.fields, rules: this.getRules(), model: this.rulesGroup[groupIndex].rules[index] })
      },
      /**
       * 删除组内条件
       */
      deleteRule (index, groupIndex) {
        this.$emit('onDeleteRule', this, { fields: this.config.fields, rules: this.getRules() })
        this.rulesGroup[groupIndex].rules.splice(index, 1)
      },
      getQueryValue (model, isTemplate) {
        let { columnType, queryValue, queryValue2, operation } = model
        if (this.isInputComponent({ columnType })) {
          if (model._queryValue === 'null') {
            return ['null']
          }
        }
        if (columnType === COLUMN_TYPE.number) {
          if (operation === OPERATIONS.between) {
            return [+queryValue, +model._queryValue]
          }
          return isNaN(queryValue) ? [queryValue] : [+queryValue]
        }
        if (columnType === COLUMN_TYPE.user && model.$attr.multiple) {
          return queryValue2
        }
        if (SINGLE_VALUE.includes(columnType)) {
          return [queryValue]
        }
        if (columnType === COLUMN_TYPE.enum && this.isEmptyOperation(model)) {
          return [queryValue]
        }
        if (columnType === COLUMN_TYPE.date) {
          let lookupCode = this.getSelectField(model).lookupCode
          let valueFormat = model.$attr.valueFormat
          if (this.isRange(model)) {
            return queryValue2.map(v => this.splitTime(v, lookupCode, valueFormat))
          } else if (isTemplate && operation === OPERATIONS.equal && !queryValue) {
            return ['null']
          } else {
            return [this.splitTime(queryValue, lookupCode, valueFormat)]
          }
        }
        if (columnType === COLUMN_TYPE.area) {
          return queryValue2.map(v => v.id)
        }
        return queryValue2
      },
      getQueryValueTemplate (model) {
        // 员工、部门 等远程搜索组件 和 9级组织
        // 保存模板时，需要同时保存 [{label,value}]，这样才能在加载模板时显示 label
        let { columnType, queryValue, queryValue2 } = model
        if (model.remoteMethod) {
          if (model.$attr.multiple) {
            // let arr = model.options.filter(v => queryValue2.includes(v.value))
            // pick label & value
            let arr = queryValue2.map(v => model.allSearchResult[v])
            arr = arr.map(v => ({ label: v.label, value: v.value }))
            return JSON.stringify(arr)
          } else {
            let obj = model.options.find(v => v.value === queryValue) || {}
            obj = { label: obj.label, value: obj.value }
            return JSON.stringify([obj])
          }
        }
        if (columnType === COLUMN_TYPE.dept || columnType === COLUMN_TYPE.customComponent) {
          return JSON.stringify(model._queryValue)
        }
        return this.getQueryValue(model, true).join()
      },
      isEmptyOperation ({ operation }) {
        return operation === OPERATIONS.equal || operation === OPERATIONS.not_equal
      },
      isRange ({ operation }) {
        return operation === OPERATIONS.between || operation === OPERATIONS.not_between
      },
      isValidQueryValue (model) {
        let { columnType, queryValue, queryValue2, operation } = model
        if (this.isInputComponent({ columnType }) && model.$attr.null && (queryValue || model._queryValue === 'null')) {
          return true
        }
        if (columnType === COLUMN_TYPE.user && model.$attr.multiple && queryValue2 && queryValue2.length) {
          return true
        }
        if (SINGLE_VALUE.includes(columnType) && queryValue) {
          return true
        }
        if (columnType === COLUMN_TYPE.number) {
          if (operation === OPERATIONS.between && !this.isEmpty(queryValue) && !this.isEmpty(model._queryValue)) {
            return true
          } else if (operation !== OPERATIONS.between && !this.isEmpty(queryValue)) {
            return true
          }
        }
        if (columnType === COLUMN_TYPE.enum) {
          if (this.isEmptyOperation(model) && queryValue) {
            return true
          }
          if (!this.isEmptyOperation(model) && queryValue2 && queryValue2.length) {
            return true
          }
        }
        if (columnType === COLUMN_TYPE.date) {
          if (!this.isRange(model) && (queryValue || model._queryValue === 'null')) {
            return true
          }
          if (this.isRange(model) && queryValue2 && queryValue2.length) {
            return true
          }
        }
        if ((columnType === COLUMN_TYPE.area || columnType === COLUMN_TYPE.dept || columnType === COLUMN_TYPE.customComponent) && queryValue2 && queryValue2.length) {
          return true
        }
        return false
      },
      isValidCompareOption (val, item, row, index, groupIndex) {
        const { key, columnType, operation } = row
        // 自定义条件关系
        const field = this.config.fields[key]
        let operations = (field && field.$attr.operations) || COMPARES[columnType]
        if (operations) {
          if (typeof operations === 'function') {
            operations = operations({field: field[key], groupName: item.groupName, groupIndex, groupRow: item, row, index})
          }
          return Array.isArray(operations) ? operations.includes(val) : false
        }
        return val === operation
      },
      getFieldOptions (model) {
        let obj = this.getSelectField(model)
        // select 前端配置 options
        let arr = obj.$attr.options || this.lookUpOptions[obj.lookupCode] || []
        if (!obj.$attr.unNull && this.isEmptyOperation(model)) {
          arr = arr.concat([{ label: '(空)', value: 'null' }])
        }
        return arr
      },
      isDisabled (key, index, groupIndex, { type } = {}) {
        // 自定义禁用方法
        if (key) {
          const { customOptionDisabled } = this.config.fields[key] && this.config.fields[key].$attr
          if (key && customOptionDisabled && typeof customOptionDisabled === 'function') {
            return customOptionDisabled({ key, groupIndex, index, type })
          }
        }
        if (key && this.config.fields[key] && this.config.fields[key].$attr.required) {
          // let firstIndex = this.rulesGroup[groupIndex].rules.findIndex(v => v.key === key)
          // if (index === firstIndex) {
          //   return true
          // }
          return this.rulesGroup[groupIndex].rules[index]._required
        }
        return false
      },
      showField (opt, item, row, index, groupIndex) {
        let show = opt.show
        try {
          const fieldAttr = opt.$attr
          if (fieldAttr.hasOwnProperty('show')) {
            show = fieldAttr.show
            if (typeof show === 'function') {
              show = show({field: opt, groupName: item.groupName, groupIndex, groupRow: item, row, index})
            }
          }
          show = !!show
        } catch (e) {}
        // 标记字段显示
        this.$set(opt, `_show-${item.groupName}`, show)
        return show
      },
      // 字段名是否禁选
      isDisabledField (opt, item, row, index, groupIndex) {
        let disabled = opt.disabledField
        try {
          disabled = opt.$attr.disabledField
          if (typeof disabled === 'function') {
            disabled = disabled({field: opt, groupName: item.groupName, groupIndex, groupRow: item, row, index})
          }
          disabled = !!disabled
        } catch (e) {}
        // 标记字段禁用
        this.$set(opt, `_disabled-${item.groupName}`, disabled)
        return disabled
      },
      // 前、后括号是否禁用
      isDisabledBrackets (key, item, row, index, groupIndex) {
        if (!key) return false
        let disabled = false
        try {
          const cur = this.config.fields[key]
          disabled = cur.$attr.disabledBrackets
          if (typeof disabled === 'function') {
            disabled = disabled({key, groupName: item.groupName, groupIndex, groupRow: item, row, index})
          }
        } catch (e) {}
        return !!disabled
      },
      // 字段条件操作符是否禁用
      isDisabledConditionOperation (key, item, row, index, groupIndex) {
        if (!key) return false
        let disabled = false
        try {
          const cur = this.config.fields[key]
          disabled = cur.$attr.disabledConditionOperation
          if (typeof disabled === 'function') {
            disabled = disabled({key, groupName: item.groupName, groupIndex, groupRow: item, row, index})
          }
        } catch (e) {}
        return !!disabled
      },
      /**
       * 是否显示删除icon
       */
      showDeleteIcon (key, index, groupIndex) {
        return !this.rulesGroup[groupIndex].rules[index].disabledRemove && (!key || !this.config.fields[key].$attr.required || !this.isDisabled(key, index, groupIndex, { type: 'deleteIcon' }))
      },
      /**
       * 是否显示增加icon
       */
      showAddIcon (key, index, groupIndex) {
        let show = true
        try {
          const fieldAttr = key && this.config.fields[key].$attr
          if (fieldAttr.hasOwnProperty('showAddIcon')) {
            show = fieldAttr.showAddIcon
            if (typeof show === 'function') {
              const item = this.rulesGroup[groupIndex]
              const row = item.rules[index]
              show = show({ key, groupName: item.groupName, groupIndex, groupRow: item, row, index })
            }
          }
        } catch (e) {}
        return !!show
      },
      getDatePickerType (key, isRange) {
        const config = this.config.fields[key]
        const type = config.$attr.type
        const isNewDate = ['datePicker3'].includes(config.lookupCode)
        if (isRange) {
          if (isNewDate && type === 'month') {
            return `${type}range`
          }
          return (type === 'date' || type === 'datetime') ? `${type}range` : 'daterange'
        }
        return type
      },
      getComponentType ({ propertyName, columnName, operation, columnType }) {
        return (propertyName || columnName) && operation && columnType
      },
      isInputComponent ({ columnType }) {
        return columnType === COLUMN_TYPE.string || columnType === COLUMN_TYPE.phone
      },
      isInputNumberComponent ({ columnType }) {
        return columnType === COLUMN_TYPE.number
      },
      isInputRange ({ columnType, operation }) {
        return columnType === COLUMN_TYPE.number && operation === OPERATIONS.between
      },
      getSelectField (model) {
        return this.config.fields[model.key] || {}
      },
      fieldsGroupVisibleChange (val) {
        if (val) {
          this.fieldsGroup = this.getFields()
        }
      },
      fieldsVisibleChange (val, row) {
        if (val) {
          const { listeners } = this.module
          if (listeners && listeners.fieldsVisibleChange && typeof listeners.fieldsVisibleChange === 'function') {
            listeners.fieldsVisibleChange(this, { fields: this.config.fields, rules: this.getRules(), model: row })
          }
          this.$emit('onFieldsVisibleChange', this, { fields: this.config.fields, rules: this.getRules(), model: row })
        }
      },
      clearFieldValue (model) {
        // 因为每个字段的类型都不一样 这里清空上次的输入值
        let obj = this.getSelectField(model)
        let type = obj.columnType
        model.propertyName = obj.propertyName
        model.columnName = obj.columnName
        model.columnType = type
        model.operation = ''
        model.queryValue = ''
        model.queryValue2 = null
        model._queryValue = ''
        model.remoteMethod = null
        model.labelKey = ''
        model.valueKey = ''
        model.$attr = obj.$attr || {}
        // 员工、部门 等远程搜索select
        if (obj.remoteMethod) {
          this.$set(model, 'loading', false)
          this.$set(model, 'options', [])
          model.remoteMethod = obj.remoteMethod
          // 2023-04-26 解决多选下拉搜索，搜索字段在搜索结果返回后清空的情况
          if (model.$attr.multiple) {
            model.queryValue2 = []
          }
          // 2022-11-28 增加属性
          model.labelKey = obj.$attr.labelKey
          model.valueKey = obj.$attr.valueKey
        }
        this.$emit('onFieldChange', model, this.config.fields, this.getRules())
      },
      operationChange (model) {
        if (model.columnType === COLUMN_TYPE.date) {
          model.queryValue = model.operation === OPERATIONS.not_equal ? 'null' : ''
          model.queryValue2 = null
          model._queryValue = ''
        } else if (model.columnType === COLUMN_TYPE.enum) {
          model.queryValue = ''
          model.queryValue2 = []
        } else if (model.columnType === COLUMN_TYPE.number || this.isInputComponent({ columnType: model.columnType })) {
          const isNull = ['equal', 'not_equal'].includes(model.operation)
          model.queryValue = isNull ? model.queryValue : ''
          model._queryValue = isNull ? model._queryValue : ''
        }
        let conf = this.module.option[model.key]
        if (conf && typeof conf.operationChange === 'function') {
          conf.operationChange(model, this.config.fields, this.rules)
        }
        this.$emit('onOperationChange', model, this.config.fields, this.getRules())
      },
      queryValueChange (model) {
        let conf = this.module.option[model.key]
        if (conf && typeof conf.change === 'function') {
          let val = this.isEmptyOperation(model) ? model.queryValue : model.queryValue2
          conf.change(val, this.config.fields, this.rules, model, { rules: this.getRules(), rulesGroup: this.rulesGroup })
        }
      },
      datePickerChange (value, model) {
        let conf = this.module.option[model.key]
        if (conf && typeof conf.change === 'function') {
          const key = model.key
          conf.change && conf.change({ key, value, model, fields: this.config.fields, rules: this.getRules() })
        }
      },
      selectVisibleChange (val, model) {
        // 远程下拉框可见时，同步下拉框
        if (val && !model.$attr.remote && typeof model.remoteMethod === 'function') {
          this.remoteMethod('--', model)
        } else {
          // 多选
          if (model.$attr.multiple && model.allSearchResult) {
            model.options = Object.keys(model.allSearchResult).reduce((prev, key) => {
              if (model.queryValue2.includes(key)) {
                const obj = model.allSearchResult[key]
                prev.push(obj)
              }
              return prev
            }, [])
          }
        }
      },
      async remoteMethod (val, model, index) {
        let arr = await remoteSelectMethod(val, model)
        if (arr.length) {
          // model.$attr.multiple && this.storeSearchResult(model)
          // 自动选中第一行
          this.$nextTick(_ => navigateSelectFirstOption(this.$refs[`remoteSelect${index}`], index))
        }
      },
      /**
       * 2021-09-15
       * 多选远程搜索时，缓存所有的下拉值
       */
      // storeSearchResult (model) {
      //   let oldObj = model.allSearchResult || Object.create(null)
      //   let newObj = model.options.reduce((prev, cur) => {
      //     prev[cur.value] = cur
      //     return prev
      //   }, {})
      //   model.allSearchResult = { ...oldObj, ...newObj }
      // },
      async searchUser (val, field) {
        let key = field.$attr.valueKey || 'id'
        let fn = field.$attr.formatterOption || (v => `${v.chineseName}，${v.position || ''}，${v.departmentName}，${v.employeeNumber}`)
        let data = field.$attr.formatData || (val => (/^\d{4,}$/.test(val) ? { employeeNumber: val } : { chineseName: val }))
        let arr = await this.$http('data.employee.listByName', data(val))
        if (arr && arr.length) {
          arr.sort((a, b) => a.status - b.status)
          // arr = arr.slice(0, 10)
          arr.forEach(v => {
            v.optionDisabled = v.status === '20'
            v.label = fn(v)
            v.value = v[key]
          })
          return arr
        }
        return []
      },
      async searchDepartment (val) {
        let arr = await this.$http('hr.department.refactoring.getByFuzzyValue', { fuzzyValue: val })
        if (arr && arr.length) {
          return arr.map(v => ({ label: `${v.name}-${v.departmentCode}`, value: v.id }))
        }
        return []
      },
      formatTime (val, type) {
        return type === 'time' && val && val.length <= 8 ? new Date(`2000-01-01 ${val}`) : val
      },
      splitTime (val, type, format) {
        if (type === 'time' && val) {
          if (val instanceof Date) {
            val = moment(val).format(format || 'HH:mm:ss')
          }
          val = val.split(' ')[0]
        }
        return val
      },
      radioDateChange (model, val) {
        if (val === 'null') {
          model.queryValue = ''
        }
      },
      radioNumberChange (model, val) {
        if (val === 'null') {
          model.queryValue = 'null'
        } else {
          model.queryValue = ''
        }
      },
      radioInputChange (model, val) {
        if (val === 'null') {
          model.queryValue = ''
        }
      },
      /**
       * 计算日期区间
       * date: [2018-12-12 00:00:00, 2018-12-12 23:59:59]
       * datetime: [2018-12-12 12:12:00, 2018-12-12 12:12:59]
       * @param val
       * @param type
       */
      calculateDateRange (val, type, format) {
        if (type === 'date') {
          return [val, val.replace('00:00:00', '23:59:59')]
        } else if (type === 'datetime') {
          return [val.replace(/:\d{2}$/, ':00'), val.replace(/:\d{2}$/, ':59')]
        } else {
          return [this.splitTime(val, type, format)]
        }
      },
      isEmpty (val) {
        return val === '' || val === null || val === undefined
      },
      bindChange (val, model) {
        if (model.$attr.multiple) {
          model.queryValue2 = val
        } else {
          model.queryValue = val
        }
      },
      openDeptTree (row, index, groupIndex) {
        this.showIndex = `${groupIndex},${index}`
        if (row.$attr.multiple) {
          this.$refs.deptMultipleDialog.open(row)
        } else {
          this.$refs.deptDialog.open(row)
        }
      },
      showDeptLabel (row) {
        let arr = row._queryValue
        if (arr && arr.length) {
          return arr.map(v => v.label).join()
        }
        return ''
      },
      deptChange (e) {
        const index = this.showIndex.split(',')
        // 是否包含子节点
        this.rulesGroup[index[0]].rules[index[1]]._containLeaf = e.leaf ? 1 : 0
        // id详情
        this.rulesGroup[index[0]].rules[index[1]]._idsInfo = e.idsInfo
      },
      // 获取多选下拉框选中的 labels，用于抓取导出查询参数的dom文本
      selectedLabels (options, val, multiple) {
        if (multiple && Array.isArray(options) && Array.isArray(val) && val.length) {
          return JSON.stringify(val.map(v => (options.find(o => v === o.value) || {}).label))
        }
        return ''
      },
      isEmptyObject (obj) {
        return obj !== null && typeof obj === 'object' && Object.keys(obj).length === 0
      },
      /**
       * 字段改变，定位到字段选择分组
       */
      fieldChange (val) {
        if (val) {
          // 分组字段切割标识
          const arr = val.split('，')
          val = arr[0]
          const groupName = arr[1] || this.config.fields[val].groupName
          const groupIndex = this.rulesGroup.findIndex(v => v.groupName === groupName)
          if (groupIndex > -1) {
            let $curDom = Array.from(this.$el.querySelectorAll('.kye-filter-rule-group-num'))[groupIndex]
            let index = this.rulesGroup[groupIndex].rules.findIndex(v => !v.key)
            if (index > -1) {
              this.handleSelectField(groupIndex, index, val)
            } else {
              this.addRule(groupIndex)
              this.handleSelectField(groupIndex, this.rulesGroup[groupIndex].rules.length - 1, val)
            }
            this.$nextTick(() => {
              // let dom = this.$el.querySelector('.kye-filter-rule-group-body')
              // let cH = dom.offsetHeight
              let h = $curDom.offsetTop + $curDom.querySelector('tr.is-active').offsetTop + 28
              this.$el.querySelector('.kye-filter-rule-group-body').scrollTo({ top: h, behavior: 'smooth' })
            })
          }
          this.field = ''
        }
      },
      /**
       * 默认选中字段
       */
      handleSelectField (groupIndex, index, val) {
        this.rulesGroup.forEach(group => {
          group.rules.forEach(item => {
            this.$set(item, '$isAcive', false)
          })
        })
        let row = this.rulesGroup[groupIndex].rules[index]
        this.$set(row, 'key', val)
        this.$set(row, '$isAcive', true)
        this.clearFieldValue(row)
      },
      rowClass ({ row }) {
        return row.$isAcive ? 'is-active' : ''
      },
      warpCustomComponentsOption (row) {
        row.setCustomValue = function (value = '', label = '') {
          let val = Array.isArray(value) ? value : [value]
          row.queryValue2 = val
          row.queryValue = label
          row._queryValue = [{ value: val, label }]
        }
        return row
      },
      setPlaceholder (row) {
        const placeholder = row.$attr.placeholder
        const openPlaceholder = row.$attr.openPlaceholder
        return openPlaceholder ? placeholder : ''
      }
    }
  }
</script>

<style lang="scss">
  .kye-filter-rule-group {
    overflow: hidden;
    &-num-head {
      margin-bottom: 8px;
      margin-right: 16px;
      padding: 0;
      border: 0;
      .el-input__inner {
        border-color: #E9E8ED;
        border-radius: 4px;
      }
      .el-table th {
        border-bottom: 0;
      }
    }
    &-body {
      position: relative;
      overflow-y: auto;
      width: 100%;
      // padding-top: 12px;
      padding-right: 16px;
      &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }

      &::-webkit-scrollbar-thumb {
        cursor: pointer;
        border-radius: 10px;
        background-color: rgba(144, 147, 153, 0.6);
        border: 1px solid white;
        //border-bottom-width: 2px;
      }

      &::-webkit-scrollbar-track {
        border: 0 solid transparent;
        background-color: #fff;
      }

      &::-webkit-scrollbar-corner {
        background: transparent;
      }

      &::-webkit-scrollbar-button {
        width: 0;
        height: 0;
        display: none;
      }
    }
    &-num {
      // position: relative;
      display: inline-block;
      height: auto;
      width: 100%;
      box-sizing: border-box;
      margin-top: 8px;
      padding: 0px 0px 7px 0px;
      border: 1px solid #E9E8ED;
      border-radius: 4px;
      background: #ffffff;
      // box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.10);
      // &:nth-child(2) {
      //   margin-top: 8px;
      // }
      &:first-child {
        margin-top: 4px;
      }
      &-item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 9px;
        padding: 8px 16px;
        line-height: 16px;
        background: #F8F8F8;
        border-radius: 4px 4px 0 0;
      }
      &-title {
        // position: absolute;
        // top: -8px;
        // left: 6px;
        display: inline-block;
        // background-color: #fff;
        text-align: left;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        max-width: 240px;
        font-size: 13px;
        color: var(--g-color-text);
        font-weight: 600;
      }
      &-operation {
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        margin-right: 14px;
      }
    }
    &-table {
      width: calc(100% - 16px);
      margin: 0 6px 0 10px;
      .el-table__empty-block {
        display: none;
      }
      .td-row-num {
        padding-top: 3px;
        text-align: center;
      }
    }
    .el-input {
      .el-input__inner {
        padding: 0 4px;
        border-color: #DCDCDC;
      }
      &.is-disabled {
        .el-input__inner {
          border-color: #DCDCDC;
        }
      }
    }
    .el-input--suffix .el-input__inner {
      padding-right: 16px !important;
      padding-left: 8px !important;
      // &[disabled] {
      //   padding-right: 8px !important;
      // }
      // border-color: #E9E8ED;
    }
    .kye-date-range__wrapper {
      padding-left: 4px !important;
      line-height: 30px;
    }
    .remote-area .area-item + .area-item {
      margin-left: 2px !important;
    }
    .el-table__body {
      padding: 0;
    }
    .el-table .cell {
      padding: 2px;
    }
    .el-table::before {
      display: none;
    }
    .el-table th {
      background: none;
    }
    .el-table tr.is-active {
      .el-input__inner {
        border-color:var(--g-color-primary);
      }
    }
    .el-table td {
      padding-bottom: 3px!important;
      border-bottom: none;
    }
    .el-table__body tr:hover > td,
    .el-table__body tr.current-row > td {
      background: #ffffff !important;
    }
    .layout-remove,
    .layout-plus2 {
      color: var(--g-color-primary);
      // border: 1px solid var(--g-color-primary);
      // border-radius: 9px;
      font-size: 12px;
      cursor: pointer;
      margin-left: 8px;
    }
    .td-front.cell {
      padding-left: 6px !important;
    }
    .td-post.cell {
      padding-left: 6px !important;
    }
    .colindex {
      display: inline-block;
      width: 16px;
      text-align: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/query-table/custom-filter-rule-group.vue